import { defaultEntityPresentation } from '@backstage/plugin-catalog-react';
import ApartmentIcon from '@material-ui/icons/Apartment';
import CategoryIcon from '@material-ui/icons/Category';
import ExtensionIcon from '@material-ui/icons/Extension';
import FeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import MemoryIcon from '@material-ui/icons/Memory';
import PeopleIcon from '@material-ui/icons/People';
import PersonIcon from '@material-ui/icons/Person';
import StorageIcon from '@material-ui/icons/Storage';

const DEFAULT_CACHE_TTL = { seconds: 10 };
const DEFAULT_BATCH_DELAY = { milliseconds: 50 };
const DEFAULT_ICONS = {
  api: ExtensionIcon,
  component: MemoryIcon,
  system: CategoryIcon,
  resource: StorageIcon,
  domain: ApartmentIcon,
  location: LocationOnIcon,
  user: PersonIcon,
  group: PeopleIcon,
  template: FeaturedPlayListIcon
};
function createDefaultRenderer(options) {
  return {
    async: options.async,
    render: ({ entityRef, entity, context }) => {
      const presentation = defaultEntityPresentation(
        entity || entityRef,
        context
      );
      return {
        snapshot: presentation,
        loadEntity: options.async
      };
    }
  };
}

export { DEFAULT_BATCH_DELAY, DEFAULT_CACHE_TTL, DEFAULT_ICONS, createDefaultRenderer };
//# sourceMappingURL=defaults.esm.js.map
